<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent scrollable max-width="1200px" content-class="processing-done-dialog">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)" novalidate>
          <v-card>
            <v-card-text class="pa-2 text-left">
              <div class="mb-2">
                <h4 class="mb-1">■加工所要時間</h4>
                <div class="py-1 text-center">
                  <div class="total-working-time mb-1">{{ formatTime(totalWorkingTimeInSeconds) }}</div>
                  <div class="total-pause-time">
                    <span>(中断時間&nbsp;&nbsp;</span>
                    <span class="total-pause-time-value">{{ formatTime(totalPauseTimeInSeconds) }}</span>
                    <span>)</span>
                  </div>
                </div>
              </div>
              <div>
                <h4 class="mb-1">■加工生産量入力</h4>
                <table class="result-table">
                  <thead>
                    <tr>
                      <th width="25%" class="text-center">加工品名称</th>
                      <th width="24%" ref="thProductAmount" class="text-center">生産量</th>
                      <th width="17%" class="text-center">目標歩留り<br />(%)</th>
                      <th width="17%" class="text-center">歩留り実績<br />(%)</th>
                      <th width="17%" class="text-center">生産性<br />(kg/h)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(product, index) in processedItemObjList" :key="product.code">
                      <th>{{ product.name }}</th>
                      <td class="full highlight">
                        <ValidationProvider :name="`processedItemObjList[${index}].amount`" class="wrapper-full"
                          :immediate="false" :bails="false" v-slot="{ errors }">
                          <input v-model="product.amount" type="number" min="0"
                            class="txt-input input-amount full text-center" :class="errors[0] ? 'invalid' : ''"
                            placeholder="0.00" @input="updateProductInfo($event.target.value, index)">
                        </ValidationProvider>
                      </td>
                      <td class="text-end">{{ product.targetPerformance }}</td>
                      <td class="text-end">{{ product.actualPerformance }}</td>
                      <td class="text-end">{{ product.productivity }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-container fluid>
                <v-row>
                  <v-col class="text-right pe-5">
                    <v-btn type="submit" color="success" class="btn-process-summary font-weight-bold"
                      :large="$vuetify.breakpoint.mdAndUp">
                      登録
                    </v-btn>
                  </v-col>
                  <v-col class="text-left ps-5">
                    <v-btn color="success" class="btn-process-summary font-weight-bold"
                      :large="$vuetify.breakpoint.mdAndUp" @click="handleClose">
                      戻る
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </form>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, double } from 'vee-validate/dist/rules';
import "vue-select/dist/vue-select.css";
import axios from "axios";
import moment from "moment";

extend('required', {
  ...required,
  message: 'この項目は必須です'
});

extend('double', {
  ...double,
  message: '０以上の数値のみ入力可'
});

extend('positive', value => {
  if (value > 0) {
    return true;
  }
  return '０以上の数値のみ入力可';
});

export default {
  name: 'ProcessingMaterialSummaryModal',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    processEmployee: {
      type: Object,
      default() {
        return null;
      },
    },
    purchasedItem: {
      type: Object,
      default() {
        return null;
      },
    },
    brand: {
      type: Object,
      default() {
        return null;
      },
    },
    inputAmount: {
      type: Number,
      required: true
    },
    totalWorkingTimeInSeconds: {
      type: Number,
      required: true
    },
    totalPauseTimeInSeconds: {
      type: Number,
      required: true
    },
    processProductItemList: {
      type: Array,
      default() {
        return [];
      },
    },
    onClose: {
      type: Function,
    },
    onSaveSuccess: {
      type: Function,
    },
    onShowError: {
      type: Function,
    },
  },
  data() {
    return {
      showSuccess: true,
      processedItemObjList: this.processProductItemList.map((product) => {
        return {
          code: product['加工品コード'],
          name: product['加工品名称'],
          amount: '',
          targetPerformance: this.formatPercentage(product['目標歩留り']),
          actualPerformance: '0',
          productivity: 0,
        };
      }),
    }
  },
  created() {
    axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
  },
  methods: {
    getCurrentDate: function () {
      return moment(new Date()).format("YYYYMMDD");
    },
    formatPercentage(str) {
      let num = parseFloat(str);
      let roundedNum = num.toFixed(2);
      return roundedNum;
    },
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((seconds % 3600) / 60)
        .toString()
        .padStart(2, "0");
      const secs = (seconds % 60).toString().padStart(2, "0");
      return `${hours}:${minutes}:${secs}`;
    },
    handleClose() {
      this.onClose?.(true);
    },
    updateProductInfo(newAmount, index) {
      const amount = parseFloat(newAmount);
      if (isNaN(amount) || !isFinite(amount)) {
        this.processedItemObjList[index].actualPerformance = '0';
        this.processedItemObjList[index].productivity = 0;
        return;
      }

      const roundedNum = (amount / this.inputAmount * 100).toFixed(2);
      this.processedItemObjList[index].actualPerformance = roundedNum;

      let productivity = '--';
      if (this.totalWorkingTimeInSeconds > 0) {
        productivity = (amount / (this.totalWorkingTimeInSeconds / 3600)).toFixed(2);
      }
      this.processedItemObjList[index].productivity = productivity;
    },
    async onSubmit() {
      // blank / non-numeric is treated as 0
      const toAmount = (v) => {
        const n = parseFloat(v);
        return isNaN(n) || !isFinite(n) ? 0 : n;
      };

      // check valid amount (0 is allowed, only negative is invalid)
      let invalidIndexes = this.processedItemObjList
        .map((product, index) => (toAmount(product.amount) < 0 ? index : -1))
        .filter(index => index !== -1);
      if (invalidIndexes.length > 0) {
        this.onShowError?.("生産量は0以上の数値で入力してください");
        invalidIndexes.forEach(i => {
          this.$refs.observer.setErrors({
            [`processedItemObjList[${i}].amount`]: '０以上の数値のみ入力可',
          });
        });
        return;
      }

      // check total productonAmount = inputAmount
      this.$refs.thProductAmount.classList.remove('invalid');
      const totalProductonAmount = this.processedItemObjList.reduce((sum, product) => {
        return sum + toAmount(product.amount);
      }, 0);
      if (totalProductonAmount !== this.inputAmount) {
        this.$refs.thProductAmount.classList.add('invalid');
        this.onShowError?.("生産量の合計が投入量と等しくなるようにしてください");
        return;
      }

      if (this.purchasedItem && this.processEmployee) {
        const processedDate = this.getCurrentDate();
        // compose payload
        const payload = {
          api_token: this.$store.state.api_token,
          store_cd: this.$store.state.tenpoCd,
          purchased_item_cd: this.purchasedItem['仕入品コード'],
          processed_date: processedDate,
          bland_cd: this.brand?.['ブランドコード'] ?? '',
          processed_time: parseFloat((this.totalWorkingTimeInSeconds / 60).toFixed(2)),
          input_amount: this.inputAmount,
          company_cd: this.processEmployee['会社コード'],
          employee_cd: this.processEmployee['社員コード'],
          processed_item_obj: this.processedItemObjList
            .filter((product) => toAmount(product.amount) > 0)
            .map((product) => {
              return {
                processed_item_cd: product.code,
                production_amount: toAmount(product.amount),
              }
            })
        };
        await axios
          .post("/api/register_kakou_result.php", payload)
          .then(() => {
            this.onClose?.(false);
            this.onSaveSuccess?.();
          })
          .catch(error => (
            console.log(error)
          ));
      }
    }
  },
}
</script>

<style>
.processing-done-dialog {
  margin: 8px !important;
}

.processing-done-dialog .v-card__text {
  color: #000 !important;
}
</style>

<style scoped>
.total-working-time {
  font-size: 24px;
  line-height: 24px;
  box-sizing: border-box;
  color: #000;
  font-weight: bold;
}


.total-pause-time {
  font-size: 14px;
  line-height: 14px;
  box-sizing: border-box;
  color: #000;
}

.total-pause-time-value {
  font-size: 18px;
  line-height: 18px;
}

/** result table */
.result-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.result-table th,
.result-table td {
  border: 1px solid #999;
  padding: 6px;
  font-weight: bold;
}

.result-table th {
  background-color: #D5E8D4;
}

.result-table thead th {
  font-size: 12px;
}

.result-table th.invalid {
  border: 1px solid red;
  outline: 1px solid red;
  background: #FFF2CC;
}

.result-table td.highlight {
  background: #FFF2CC;
  font-size: 16px;
}

.result-table td.full {
  position: relative;
}

.result-table td.full .wrapper-full {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.result-table .txt-input.full {
  width: 100%;
  height: 100%;
}

.result-table .txt-input.invalid,
.result-table .txt-input.invalid:focus-visible {
  border: 1px solid red;
  outline: 1px solid red;
}

/* For Chrome, Safari, Edge, and Opera */
.input-amount[type="number"]::-webkit-outer-spin-button,
.input-amount[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
.input-amount[type="number"] {
  -moz-appearance: textfield;
}

.btn-process-summary.v-size--default {
  min-width: 128px !important;
}

@media only screen and (min-width: 430px) {
  .result-table {
    font-size: 16px;
  }
}

/** responsive tablet */
@media only screen and (min-width: 960px) {
  .v-card__text {
    font-size: 18px;
  }

  .total-working-time {
    font-size: 48px;
    line-height: 48px;
  }


  .total-pause-time {
    font-size: 28px;
    line-height: 28px;
  }

  .total-pause-time-value {
    font-size: 33px;
    line-height: 33px;
  }

  .result-table {
    font-size: 20px;
  }

  .result-table th,
  .result-table td {
    padding: 20px 8px;
  }

  .v-btn.v-size--large {
    min-width: 160px;
    font-size: 24px;
    height: 54px;
  }
}
</style>